<script>
	import { createEventDispatcher } from 'svelte';

	export let conference = {};
	export let agent = {};

	const dispatch = createEventDispatcher();

	function hangup() {
		dispatch('hangup');
	}

	function call() {
		dispatch('call');
	}

	function join() {
		dispatch('join');
	}
</script>

<style>
	.round-name {
		width: 75px;
		height: 75px;
		font-size: 1.5em;
		justify-self: center;
	}
	#contact-info-header {
		display: grid;
		justify-content: center;
	}
	.dropdown-toggle {
		cursor: pointer;
	}
</style>

<div class="card">
	<div class="card-body">
		<div class="dropdown float-end">
			<div class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
				<i class="mdi mdi-dots-horizontal"></i>
			</div>
		</div>

		<div id="contact-info-header" class="mt-3 text-center">
			<div class="round-name">{agent.initials}</div>
			<h4>{agent.name}</h4>
			{#if conference?.active}
				<button class="btn btn-danger btn-sm mt-1" on:click={hangup}><i class='uil uil-incoming-call me-1'></i>Hangup</button>
			{:else if conference?.showActive}
				<button class="btn btn-success btn-sm mt-1" on:click={join}><i class='uil uil-outgoing-call me-1'></i>Join</button>
			{:else}
				<button class="btn btn-success btn-sm mt-1" on:click={call}><i class='uil uil-outgoing-call me-1'></i>Call</button>
			{/if}
			{#if conference?.active}
				<p class="text-muted mt-2 font-14">Active for: <strong>{conference?.formattedDuration} minutes</strong></p>
			{/if}
		</div>
	</div>
</div>